import {txt, type Texto} from '../i18n/idioma';

// Notas (i) del inventario (Daniel, 14/10/2026): qué es cada campo y cómo se
// llena. Las usan la tabla del Consolidado, la ficha del Big Bag, la edición,
// el cambio en lote, los filtros, la carga del control de empaque y las
// Recolecciones. "Consolidated" = el Consolidated Shipments.xlsx (hojas
// Storage y Exported); "en el archivo" = la columna de ese libro.

// Un dato de un Big Bag, por el id de su columna en la tabla (el mismo nombre
// que usa la edición).
export const AYUDA_BIG_BAG = {
  bbNo: txt(
    'Número del Big Bag. Su prefijo (BV, CM, S-MM…) dice de qué mina, proveedor, exportador y planta es. En el Consolidated: BB #. No se repite.',
    'Big Bag number. Its prefix (BV, CM, S-MM…) tells its mine, supplier, exporter and plant. In the Consolidated: BB #. It is unique.',
  ),
  estado: txt(
    'Disponible = en bodega sin exportación; Asignado = ya tiene exportación pero no ha salido; Exportado = está en la hoja Exported, tiene día de llenado o su exportación ya salió. Lo calcula la app.',
    'Available = in the warehouse with no export; Assigned = has an export but has not left; Exported = it is in the Exported sheet, has a filling date or its export already left. The app works it out.',
  ),
  linea: txt(
    'A qué inventario pertenece: CNC (el del Consolidated) o Mineros, que se carga de sus propios archivos y se lleva aparte.',
    'Which inventory it belongs to: CNC (the Consolidated one) or Mineros, which is loaded from its own files and kept apart.',
  ),
  exportacion: txt(
    'Exportación a la que está ligado o con la que salió. En el Consolidated: EXPORT. También se cambia en la app (Cambiar exportación, asignación por reserva).',
    'Export it is linked to or left with. In the Consolidated: EXPORT. It can also be changed in the app (Change export, assignment by booking).',
  ),
  recoleccion: txt(
    'Recolección (S-###) con la que llegó a la bodega. En el Consolidated o en el control de empaque: Shipment #; "Directo" = Direct Ship, salió sin pasar por bodega. Se puede editar.',
    'Pickup (S-###) it arrived at the warehouse with. In the Consolidated or the packing control: Shipment #; "Direct" = Direct Ship, it left without going through the warehouse. It can be edited.',
  ),
  contenedor: txt(
    'Contenedor de exportación (el de la naviera) en que viaja. En el Consolidated: Container; también llega del Seguimiento Concentrados o de la asignación por reserva. Solo se pone si el Big Bag tiene exportación; máximo 28 por contenedor.',
    'Export container (the shipping line one) it travels in. In the Consolidated: Container; it also comes from Seguimiento Concentrados or from the booking assignment. Only set if the Big Bag has an export; at most 28 per container.',
  ),
  fechaEmpaque: txt(
    'Día en que se empacó el Big Bag en la planta. En el Consolidated y en el control de empaque: DATE PACKED.',
    'Day the Big Bag was packed at the plant. In the Consolidated and the packing control: DATE PACKED.',
  ),
  sello: txt(
    'Sello de seguridad del Big Bag. En el archivo: SECURITY SEAL. Si se cambia en la app, el sello anterior queda guardado.',
    'Security seal of the Big Bag. In the file: SECURITY SEAL. If it is changed in the app, the previous seal is kept.',
  ),
  tipoMaterial: txt(
    'Tipo de material (MIX, JIG, FLO, LAB…). En el archivo: TYPE (o TYPE X), escrito de una sola forma. En Colombian Mint la app cambia MIX por FLO si el BB # empieza por CM o S-CM, y por JIG en los demás.',
    'Material type (MIX, JIG, FLO, LAB…). In the file: TYPE (or TYPE X), written one single way. For Colombian Mint the app changes MIX to FLO if the BB # starts with CM or S-CM, and to JIG otherwise.',
  ),
  tonHumedas: txt(
    'Peso húmedo en toneladas. En el archivo: WEIGHT WET (Ton). Un contenedor lleva unas 28 toneladas húmedas.',
    'Wet weight in tonnes. In the file: WEIGHT WET (Ton). A container carries about 28 wet tonnes.',
  ),
  tonSecas: txt(
    'Peso seco en toneladas. En el archivo: WEIGHT DRY (Ton); si no viene, la app la calcula: húmedas × (1 − % MOISTURE PACKED). No puede ser más que las húmedas.',
    'Dry weight in tonnes. In the file: WEIGHT DRY (Ton); if missing, the app works it out: wet × (1 − % MOISTURE PACKED). It cannot be more than the wet weight.',
  ),
  auGt: txt(
    'Tenor de oro: gramos por tonelada seca. En el archivo: Au (g/t).',
    'Gold grade: grams per dry tonne. In the file: Au (g/t).',
  ),
  auG: txt(
    'Gramos de oro. En el archivo: Au (g); si no viene, la app los calcula: toneladas secas × Au (g/t). Al editarlos avisa si no cuadran con el tenor.',
    'Grams of gold. In the file: Au (g); if missing, the app works them out: dry tonnes × Au (g/t). When edited it warns if they do not match the grade.',
  ),
  agGt: txt(
    'Tenor de plata: gramos por tonelada seca. En el archivo: Ag (g/t).',
    'Silver grade: grams per dry tonne. In the file: Ag (g/t).',
  ),
  agG: txt(
    'Gramos de plata. En el archivo: Ag (g); si no viene, la app los calcula: toneladas secas × Ag (g/t).',
    'Grams of silver. In the file: Ag (g); if missing, the app works them out: dry tonnes × Ag (g/t).',
  ),
  auOz: txt(
    'Onzas troy de oro. En el archivo: Au Oz; si no viene, o si se editan los gramos, la app las calcula: gramos ÷ 31,1034768.',
    'Troy ounces of gold. In the file: Au Oz; if missing, or when the grams are edited, the app works them out: grams ÷ 31.1034768.',
  ),
  agOz: txt(
    'Onzas troy de plata. En el archivo: Ag oz; si no viene, o si se editan los gramos, la app las calcula: gramos ÷ 31,1034768.',
    'Troy ounces of silver. In the file: Ag oz; if missing, or when the grams are edited, the app works them out: grams ÷ 31.1034768.',
  ),
  humedad: txt(
    'Porcentaje de agua del Big Bag. Lo calcula la app: (húmedas − secas) ÷ húmedas × 100.',
    'Water percentage of the Big Bag. The app works it out: (wet − dry) ÷ wet × 100.',
  ),
  mesMolienda: txt(
    'Mes de molienda oficial: el que usan las regalías y los documentos. En el Consolidated: MES MOLIENDA. Se puede corregir en la app.',
    'Official grinding month: the one used for royalties and documents. In the Consolidated: MES MOLIENDA. It can be corrected in the app.',
  ),
  mesMoliendaReal: txt(
    'Mes de molienda real, solo como referencia. En el archivo: Real Grinding Month (o Grinding Month); si no viene, se muestra el oficial.',
    'Real grinding month, for reference only. In the file: Real Grinding Month (or Grinding Month); if missing, the official one is shown.',
  ),
  etd: txt(
    'Zarpe de la exportación del Big Bag, tomado del seguimiento de exportaciones (hoja Tracking Status del Status, la reserva o lo editado en Exportaciones). Sin exportación queda vacío.',
    'Departure of the Big Bag’s export, taken from the export tracking (Tracking Status sheet of the Status, the booking or edits in Exports). Empty without an export.',
  ),
  eta: txt(
    'Llegada de la exportación del Big Bag, tomada del seguimiento de exportaciones. Sin exportación queda vacía.',
    'Arrival of the Big Bag’s export, taken from the export tracking. Empty without an export.',
  ),
  mesMoliendaReportado: txt(
    'Mes de molienda tal como venía en la columna MES MOLIENDA del archivo, sin las correcciones hechas en la app.',
    'Grinding month exactly as it came in the MES MOLIENDA column of the file, without the corrections made in the app.',
  ),
  mina: txt(
    'Mina de donde sale el concentrado. En el archivo: Mine; si no viene, la app la deduce del prefijo del BB #. Se elige de la lista al editar.',
    'Mine the concentrate comes from. In the file: Mine; if missing, the app works it out from the BB # prefix. Picked from the list when editing.',
  ),
  proveedor: txt(
    'Proveedor del concentrado. En el archivo: Supplier; si no viene, la app lo deduce del prefijo del BB #.',
    'Supplier of the concentrate. In the file: Supplier; if missing, the app works it out from the BB # prefix.',
  ),
  exportador: txt(
    'Empresa que exporta el Big Bag. En el archivo: Exporter; si no viene, la app lo deduce del prefijo del BB #.',
    'Company that exports the Big Bag. In the file: Exporter; if missing, the app works it out from the BB # prefix.',
  ),
  planta: txt(
    'Planta donde se produjo el concentrado. En el archivo: Plant; si no viene, la app la deduce del prefijo del BB #.',
    'Plant where the concentrate was produced. In the file: Plant; if missing, the app works it out from the BB # prefix.',
  ),
  ubicacion: txt(
    'Bodega donde está, o donde estuvo antes de exportarse. En el Consolidated: Location (hoja Storage) u Origin (hoja Exported). Se elige de la lista al editar.',
    'Warehouse where it is, or was before being exported. In the Consolidated: Location (Storage sheet) or Origin (Exported sheet). Picked from the list when editing.',
  ),
  municipio: txt(
    'Municipio de origen del concentrado. En el archivo: Municipio (y Municipio Code).',
    'Municipality the concentrate comes from. In the file: Municipio (and Municipio Code).',
  ),
  entradaBodega: txt(
    'Día en que el Big Bag entró a la bodega. En el Consolidated: Entry Date (o Entry to storage). También se pone para toda una recolección en Recolecciones → Ingreso a bodega.',
    'Day the Big Bag entered the warehouse. In the Consolidated: Entry Date (or Entry to storage). It can also be set for a whole pickup in Pickups → Warehouse entry.',
  ),
  fechaLlenado: txt(
    'Día en que el Big Bag se cargó en el contenedor. En el Consolidated: Dia-Llenado. Si tiene exportación, con esta fecha pasa a Exportado.',
    'Day the Big Bag was loaded into the container. In the Consolidated: Dia-Llenado. If it has an export, this date makes it Exported.',
  ),
  numeroAnterior: txt(
    'Número que tenía el Big Bag antes de renumerarlo. En el archivo: BB Id Old.',
    'Number the Big Bag had before it was renumbered. In the file: BB Id Old.',
  ),
  selloAnterior: txt(
    'Sello que tenía antes. En el archivo: Seal Id Old; cuando se cambia el sello en la app, el que se reemplaza queda aquí.',
    'Seal it had before. In the file: Seal Id Old; when the seal is changed in the app, the replaced one is kept here.',
  ),

  // Columnas del Consolidated que la app guarda tal cual y solo muestra.
  'x.invoiceDate': txt(
    'Fecha de la factura. Copia de la columna Invoice Date del Consolidated.',
    'Invoice date. Copy of the Invoice Date column of the Consolidated.',
  ),
  'x.invoiceYear': txt(
    'Año de la factura. Copia de la columna Invoice Year del Consolidated.',
    'Invoice year. Copy of the Invoice Year column of the Consolidated.',
  ),
  'x.shipmentNule': txt(
    'Copia de la columna Shipment Nule del Consolidated.',
    'Copy of the Shipment Nule column of the Consolidated.',
  ),
  'x.typeX': txt(
    'Copia de la columna TYPE X del Consolidated, tal como venía.',
    'Copy of the TYPE X column of the Consolidated, as it came.',
  ),
  'x.materialType': txt(
    'Tipo de material tal como venía en la columna TYPE del Consolidated, antes de normalizarlo.',
    'Material type as it came in the TYPE column of the Consolidated, before normalizing it.',
  ),
  'x.moisturePacked': txt(
    'Humedad al empacar, tal como venía en la columna % MOISTURE PACKED del Consolidated.',
    'Moisture when packed, as it came in the % MOISTURE PACKED column of the Consolidated.',
  ),
  'x.miningTitle': txt(
    'Título minero que imprimen los documentos de aduana. La app lo pone en cada carga: el que trae el archivo (Mining Title) o el vigente de su mina.',
    'Mining title printed on the customs documents. The app sets it on every load: the one in the file (Mining Title) or the current one of its mine.',
  ),
  'x.soldTo': txt(
    'A quién se vendió. Copia de la columna Sold to del Consolidated.',
    'Who it was sold to. Copy of the Sold to column of the Consolidated.',
  ),
  'x.origin': txt(
    'Bodega de origen en la hoja Exported. Copia de la columna Origin del Consolidated.',
    'Origin warehouse in the Exported sheet. Copy of the Origin column of the Consolidated.',
  ),
  'x.departure': txt(
    'Copia de la columna Departure del Consolidated.',
    'Copy of the Departure column of the Consolidated.',
  ),
  'x.arrival': txt('Copia de la columna Arrival del Consolidated.', 'Copy of the Arrival column of the Consolidated.'),
  'x.portOfLoading': txt(
    'Puerto de carga. Copia de la columna Port of Loading del Consolidated.',
    'Port of loading. Copy of the Port of Loading column of the Consolidated.',
  ),
  'x.eta': txt(
    'Llegada según el Consolidated (columna ETA). La de la exportación está en Llegada (ETA).',
    'Arrival according to the Consolidated (ETA column). The export one is in Arrival (ETA).',
  ),
  'x.financedByBlq': txt(
    'Copia de la columna Financed by BLQ del Consolidated.',
    'Copy of the Financed by BLQ column of the Consolidated.',
  ),
  'x.blDate': txt(
    'Fecha del BL. Copia de la columna BL Date del Consolidated.',
    'BL date. Copy of the BL Date column of the Consolidated.',
  ),
  'x.liquidationDate': txt(
    'Fecha de liquidación. Copia de la columna Liquidation Date del Consolidated.',
    'Settlement date. Copy of the Liquidation Date column of the Consolidated.',
  ),
  'x.code': txt('Copia de la columna CODE del Consolidated.', 'Copy of the CODE column of the Consolidated.'),
  'x.hindustanArrivalDate': txt(
    'Llegada a la refinería del comprador. Copia de la columna Hindustan Arrival Date del Consolidated.',
    'Arrival at the buyer’s refinery. Copy of the Hindustan Arrival Date column of the Consolidated.',
  ),
  'x.ozAuPriceBb': txt(
    'Copia de la columna Oz Au Price X BB del Consolidated.',
    'Copy of the Oz Au Price X BB column of the Consolidated.',
  ),
  'x.ozAgPriceBb': txt(
    'Copia de la columna Oz Ag Price X BB del Consolidated.',
    'Copy of the Oz Ag Price X BB column of the Consolidated.',
  ),
  'x.trm': txt(
    'Tasa de cambio (TRM). Copia de la columna TRM del Consolidated.',
    'Exchange rate (TRM). Copy of the TRM column of the Consolidated.',
  ),
  'x.municipioCode': txt(
    'Código del municipio. Copia de la columna Municipio Code del Consolidated.',
    'Municipality code. Copy of the Municipio Code column of the Consolidated.',
  ),
  'x.billed': txt(
    'Si ya se facturó. Copia de la columna Billed del Consolidated.',
    'Whether it was invoiced. Copy of the Billed column of the Consolidated.',
  ),
  'x.entryMonth': txt(
    'Mes de entrada. Copia de la columna ED Month del Consolidated.',
    'Entry month. Copy of the ED Month column of the Consolidated.',
  ),
  'x.auOzPriceToday': txt(
    'Copia de la columna AU Oz Price today del Consolidated (el valor del día en que se guardó el archivo).',
    'Copy of the AU Oz Price today column of the Consolidated (the value on the day the file was saved).',
  ),
  'x.currentDateMinusOne': txt(
    'Copia de la columna Current date -1 del Consolidated.',
    'Copy of the Current date -1 column of the Consolidated.',
  ),
} satisfies Record<string, Texto>;

// Filtros del Consolidado.
export const AYUDA_FILTROS_INVENTARIO = {
  linea: txt(
    'Qué inventario ver: Unificado (todos), CNC (el del Consolidated) o Mineros. El número es cuántos Big Bags hay con los demás filtros.',
    'Which inventory to see: Unified (all), CNC (the Consolidated one) or Mineros. The number is how many Big Bags there are with the other filters.',
  ),
  buscar: txt(
    'Busca un texto dentro del BB #, la exportación, el sello, el contenedor o la recolección.',
    'Searches for text in the BB #, export, seal, container or pickup.',
  ),
  estado: txt(
    'Disponible, Asignado o Exportado. Sin filtros la tabla abre solo con los disponibles; sin ninguno marcado se ven todos.',
    'Available, Assigned or Exported. With no filters the table opens with the available ones only; with none ticked all are shown.',
  ),
  exportador: txt('Empresa que exporta los Big Bags.', 'Company that exports the Big Bags.'),
  exportacion: txt(
    'Exportación de los Big Bags; "Sin exportación" = los que no tienen. Para una parte del código usa Buscar.',
    'Export of the Big Bags; "No export" = those without one. For part of a code use Search.',
  ),
  mesEtd: txt('Mes de zarpe de la exportación de cada Big Bag.', 'Departure month of each Big Bag’s export.'),
  mesEta: txt('Mes de llegada de la exportación de cada Big Bag.', 'Arrival month of each Big Bag’s export.'),
  proveedor: txt('Proveedor del concentrado.', 'Supplier of the concentrate.'),
  mina: txt('Mina de donde sale el concentrado.', 'Mine the concentrate comes from.'),
  planta: txt('Planta donde se produjo el concentrado.', 'Plant where the concentrate was produced.'),
  ubicacion: txt('Bodega donde está o estuvo el Big Bag.', 'Warehouse where the Big Bag is or was.'),
  recoleccion: txt(
    'Recolección (S-###) con la que llegaron a la bodega.',
    'Pickup (S-###) they arrived at the warehouse with.',
  ),
  mesMolienda: txt('Mes de molienda oficial (MES MOLIENDA).', 'Official grinding month (MES MOLIENDA).'),
  etdDesde: txt('Zarpe de la exportación desde este día (incluido).', 'Export departure from this day (included).'),
  etdHasta: txt('Zarpe de la exportación hasta este día (incluido).', 'Export departure up to this day (included).'),
  etaDesde: txt('Llegada de la exportación desde este día (incluido).', 'Export arrival from this day (included).'),
  etaHasta: txt('Llegada de la exportación hasta este día (incluido).', 'Export arrival up to this day (included).'),
  origen: txt(
    'De qué carga vino el Big Bag: el Consolidated vigente o un consolidado histórico (años anteriores).',
    'Which load the Big Bag came from: the current Consolidated or a historical consolidated file (earlier years).',
  ),
};

// Cambios sobre los Big Bags marcados en la tabla.
export const AYUDA_CAMBIOS_BIG_BAGS = {
  dato: txt(
    'Qué dato se pone igual en todos los Big Bags marcados. Pesos, tenores, gramos y sellos se cambian uno por uno en la ficha.',
    'Which field is set the same on all the ticked Big Bags. Weights, grades, grams and seals are changed one by one on the record.',
  ),
  valorNuevo: txt(
    'El valor que van a tener. Vacío = borrar el dato. Primero se revisa qué cambia en cada uno y luego se aplica.',
    'The value they will have. Empty = clear the field. First you review what changes in each one, then apply.',
  ),
  exportacionNueva: txt(
    'Código de la exportación a la que pasan los Big Bags marcados. Vacío = quedan sin exportación (disponibles). Salen de su contenedor anterior.',
    'Code of the export the ticked Big Bags move to. Empty = they are left with no export (available). They leave their previous container.',
  ),
};

// Carga del Consolidated: columnas de las diferencias.
export const AYUDA_CONSOLIDADO = {
  enElArchivo: txt(
    'Exportación que el Consolidated les da a estos Big Bags. "(Exported)" = vienen de la hoja Exported.',
    'Export the Consolidated gives these Big Bags. "(Exported)" = they come from the Exported sheet.',
  ),
  enLaApp: txt('Exportación que tienen hoy en la app.', 'Export they have in the app today.'),
  bb: txt(
    'Cuántos Big Bags tienen esa diferencia. Clic para ver cuáles.',
    'How many Big Bags have that difference. Click to see which.',
  ),
  queHacer: txt(
    'Los que no tienen exportación en la app se asignan como el archivo. En los demás marca si pasarlos a la del archivo o quitarles la exportación; sin marcar no cambian.',
    'Those without an export in the app get assigned as in the file. For the rest tick whether to move them to the file’s export or remove their export; unticked ones do not change.',
  ),
  mesDeMolienda: txt(
    'Big Bags cuyo MES MOLIENDA en el archivo es distinto del de la app. Marca los que quieres corregir como el archivo.',
    'Big Bags whose MES MOLIENDA in the file differs from the app. Tick the ones you want to correct as in the file.',
  ),
};

// Carga del control de empaque de una recolección.
export const AYUDA_CARGAS = {
  mesInusual: txt(
    'Por cada exportador y mina, el archivo debería traer un solo mes de molienda y seguir lo que se venía cargando (el mismo mes o el siguiente). Sale este aviso si el archivo trae varios meses, salta meses o vuelve a un mes anterior. No impide guardar: revisa con la planta antes.',
    'For each exporter and mine, the file should bring a single grinding month and follow what was being loaded (the same month or the next). This notice shows when the file brings several months, skips months or goes back to an earlier month. It does not block saving: check with the plant first.',
  ),
  entradaABodega: txt(
    'Fecha en que la recolección entró a la bodega. Viene propuesta con la del archivo o con la descarga del camión. Al aplicar se pone en todos los Big Bags de la recolección, también los de cargas anteriores. Déjala vacía si todavía no ha llegado.',
    'Date the pickup entered the warehouse. It comes proposed from the file or from the truck unloading. When applying, it is set on all the Big Bags of the pickup, also those from earlier uploads. Leave it empty if it has not arrived yet.',
  ),
  diferencias: txt(
    'Big Bags del archivo que ya estaban en la app y los datos que cambian si guardas: lo de hoy tachado y lo que queda con el archivo. Los datos que el archivo trae vacíos no se borran.',
    "Big Bags in the file that were already in the app and the values that change if you save: today's value crossed out and the one the file leaves. Values the file brings empty are not erased.",
  ),
  archivo: txt(
    'Formato de control de empaque de una recolección (Excel). La app lee la hoja que tiene la columna BB #.',
    'Packing control file of a pickup (Excel). The app reads the sheet that has the BB # column.',
  ),
  fechaRecoleccion: txt(
    'Opcional. Día de la recolección; se guarda en la recolección si todavía no tiene fecha. Vale para todos los archivos elegidos.',
    'Optional. Day of the pickup; it is saved on the pickup if it has no date yet. It applies to all the chosen files.',
  ),
  recoleccion: txt(
    'Recolección (S-###) de este archivo. Vacía = la de la columna Shipment # o el S-número del nombre del archivo. Escríbela solo si el archivo no la trae o la trae mal.',
    'Pickup (S-###) of this file. Empty = the one in the Shipment # column or the S-number in the file name. Enter it only if the file has none or a wrong one.',
  ),
  filas: txt('Big Bags que trae el archivo.', 'Big Bags in the file.'),
  nuevas: txt(
    'Big Bags que no existen en la app: entran como disponibles.',
    'Big Bags that do not exist in the app: they come in as available.',
  ),
  existentes: txt(
    'Big Bags que ya están en la app: se actualizan sin cambiar su exportación ni su estado.',
    'Big Bags already in the app: they are updated without changing their export or status.',
  ),
  resultado: txt(
    'Nueva = entra al inventario; Existente = ya estaba y se actualiza (si tiene exportación, se muestra).',
    'New = enters the inventory; Existing = it was already there and is updated (if it has an export, it is shown).',
  ),
  totales: txt('Suma de los Big Bags del archivo.', 'Total of the Big Bags in the file.'),
  wmt: txt('Toneladas húmedas. En el archivo: WEIGHT WET (Ton).', 'Wet tonnes. In the file: WEIGHT WET (Ton).'),
  dmt: txt(
    'Toneladas secas. En el archivo: WEIGHT DRY (Ton); si no viene, húmedas × (1 − % MOISTURE PACKED).',
    'Dry tonnes. In the file: WEIGHT DRY (Ton); if missing, wet × (1 − % MOISTURE PACKED).',
  ),
  // Últimas cargas.
  fecha: txt('Cuándo se subió el archivo.', 'When the file was uploaded.'),
  tipo: txt('Qué clase de archivo se cargó.', 'What kind of file was loaded.'),
  nombreArchivo: txt('Nombre del archivo que se subió.', 'Name of the uploaded file.'),
  recoleccionCarga: txt('Recolección a la que se aplicó.', 'Pickup it was applied to.'),
  estado: txt(
    'Recibida, revisada sin aplicar, aplicada o fallida (con el motivo).',
    'Received, reviewed but not applied, applied or failed (with the reason).',
  ),
  actualizadas: txt('Big Bags que ya existían y se actualizaron.', 'Big Bags that already existed and were updated.'),
};

// Un viaje de camión (Recolecciones), por el id de su columna o de su campo.
const VEHICULO = txt(
  'Tipo de vehículo (TM = tractomula, DT = doble troque…). En el archivo: Tipo de vehiculo.',
  'Vehicle type (TM = tractor-trailer, DT = double-axle truck…). In the file: Tipo de vehiculo.',
);
const CONTENEDOR_TERRESTRE = txt(
  'Contenedor del camión, no el de la naviera. En el archivo: Contenedor.',
  'Truck container, not the shipping line one. In the file: Contenedor.',
);
export const AYUDA_VIAJE = {
  recoleccion: txt(
    'Recolección (S-###) que lleva el viaje. Viene de la hoja Recolecciones del Concentrates Summary (columna Recoleccion); las recolecciones del Consolidated sin viaje tienen uno creado por la app para completar.',
    'Pickup (S-###) the trip carries. It comes from the Recolecciones sheet of the Concentrates Summary (Recoleccion column); Consolidated pickups without a trip get one created by the app to complete.',
  ),
  salida: txt(
    'Día en que el camión salió de la bodega de Quintana. En el archivo: Salida Quintana. Con * la app corrigió una fecha imposible (año o mes mal escrito); pasa el cursor para ver la original.',
    'Day the truck left the Quintana warehouse. In the file: Salida Quintana. With * the app fixed an impossible date (wrong year or month); hover to see the original.',
  ),
  descarga: txt(
    'Día de la descarga en Cartagena o Barrancabermeja: es el ingreso a bodega de sus Big Bags. En el archivo: Descarga CTG / Bmeja. En los viajes creados por la app, la primera entrada a bodega de sus Big Bags.',
    'Day of unloading in Cartagena or Barrancabermeja: it is the warehouse entry of its Big Bags. In the file: Descarga CTG / Bmeja. On trips created by the app, the first warehouse entry of its Big Bags.',
  ),
  dias: txt(
    'Días del viaje. Lo calcula la app: descarga − salida.',
    'Days of the trip. The app works it out: unloading − departure.',
  ),
  destino: txt(
    'Cartagena o Barrancabermeja. En el archivo: DESTINO.',
    'Cartagena or Barrancabermeja. In the file: DESTINO.',
  ),
  transportista: txt(
    'Empresa de transporte del viaje. En el archivo: TRANSPORTISTA.',
    'Transport company of the trip. In the file: TRANSPORTISTA.',
  ),
  vehiculo: VEHICULO,
  tipoVehiculo: VEHICULO,
  contenedor: CONTENEDOR_TERRESTRE,
  contenedorTerrestre: CONTENEDOR_TERRESTRE,
  toneladas: txt('Toneladas que llevó el camión. En el archivo: TON.', 'Tonnes the truck carried. In the file: TON.'),
  conductor: txt(
    'Nombre del conductor. En el archivo: Conductor. Solo lo ven y lo cambian los administradores.',
    'Driver name. In the file: Conductor. Only administrators see and change it.',
  ),
  cedula: txt(
    'Cédula del conductor, solo dígitos. En el archivo: Cedula. Solo para administradores.',
    'Driver ID number, digits only. In the file: Cedula. Administrators only.',
  ),
  placa: txt(
    'Placa del camión, sin espacios ni guiones (ABC123). En el archivo: Placa vehiculo. Solo para administradores.',
    'Truck plate, without spaces or dashes (ABC123). In the file: Placa vehiculo. Administrators only.',
  ),
  estado: txt(
    'Realizado o Cancelado. Queda cancelado si el DESTINO del archivo dice anulada, cancelada o contingencia; al lado va el motivo.',
    'Completed or Cancelled. It is cancelled if the DESTINO in the file says annulled, cancelled or contingency; the reason is shown next to it.',
  ),
  motivoCancelacion: txt('Por qué no se hizo el viaje.', 'Why the trip did not happen.'),
  revision: txt(
    'La app lo marca cuando algo no cuadra: fechas imposibles o datos que faltan (sin toneladas, conductor sin cédula válida).',
    'The app flags it when something does not add up: impossible dates or missing data (no tonnes, driver without a valid ID).',
  ),
  notas: txt(
    'Notas libres del viaje. En el archivo: NOTAS; se editan en la app.',
    'Free notes about the trip. In the file: NOTAS; edited in the app.',
  ),
  editado: txt(
    'Quién y cuándo cambió el viaje en la app. Un viaje editado no lo reemplaza una nueva carga del archivo.',
    'Who changed the trip in the app and when. An edited trip is not replaced by a new load of the file.',
  ),
} satisfies Record<string, Texto>;

// Filtros de Recolecciones.
export const AYUDA_FILTROS_VIAJES = {
  buscar: txt(
    'Busca en la recolección y el contenedor terrestre (los administradores también en placa y conductor).',
    'Searches the pickup and the inland container (administrators also plate and driver).',
  ),
  anio: txt(
    'Año de la salida de Quintana (o del ingreso a bodega si no tiene salida).',
    'Year of departure from Quintana (or of warehouse entry if there is no departure).',
  ),
  transportista: txt('Empresa de transporte.', 'Transport company.'),
  destino: txt('Cartagena o Barrancabermeja.', 'Cartagena or Barrancabermeja.'),
  estado: txt('Realizado o Cancelado.', 'Completed or Cancelled.'),
  soloParaRevisar: txt(
    'Solo los viajes que la app marcó para revisar (fechas imposibles o datos que faltan).',
    'Only the trips the app flagged for review (impossible dates or missing data).',
  ),
};

// Ingreso a bodega de una recolección.
export const AYUDA_ENTRADA_A_BODEGA = {
  recoleccion: txt(
    'Recolección (S-###) a cuyos Big Bags se les pone la fecha.',
    'Pickup (S-###) whose Big Bags get the date.',
  ),
  fecha: txt(
    'Día en que los Big Bags entraron a la bodega. Al revisar, la app sugiere la descarga del viaje de camión.',
    'Day the Big Bags entered the warehouse. When reviewing, the app suggests the truck trip unloading date.',
  ),
  alcance: txt(
    'Solo los Big Bags sin fecha de ingreso, o todos (reemplaza las fechas que tengan).',
    'Only the Big Bags without an entry date, or all of them (replaces existing dates).',
  ),
};

// Ficha de un Big Bag de Mineros: lo que no esta ya en AYUDA_MINEROS (ayuda-mineros.ts).
export const AYUDA_FICHA_MINEROS = {
  etapa: txt(
    'Dónde está hoy: Planta El Bagre, Camino a Cartagena, Bodega de Cartagena, En puerto, Navegando, Llegó a destino o Entregado. La calcula la app con sus fechas; "(disponible)" = todavía sin exportación.',
    'Where it is today: El Bagre plant, on the way to Cartagena, Cartagena warehouse, in port, at sea, arrived or delivered. The app works it out from its dates; "(available)" = no export yet.',
  ),
  pesoCargue: txt(
    'Peso al cargar el camión en El Bagre (kg). En la base de la bodega: PESO CARGUE.',
    'Weight when loading the truck in El Bagre (kg). In the warehouse database: PESO CARGUE.',
  ),
  precintoCargue: txt(
    'Precinto al cargar el camión en El Bagre. En la base de la bodega: PRECINTO CARGUE.',
    'Seal when loading the truck in El Bagre. In the warehouse database: PRECINTO CARGUE.',
  ),
  pesoIngreso: txt(
    'Peso al ingresar a la bodega de Cartagena (kg). En la base de la bodega: PESO DESCARGUE.',
    'Weight on entering the Cartagena warehouse (kg). In the warehouse database: PESO DESCARGUE.',
  ),
  precintoIngreso: txt(
    'Precinto al ingresar a la bodega de Cartagena. En la base de la bodega: PRECINTO DESCARGUE.',
    'Seal on entering the Cartagena warehouse. In the warehouse database: PRECINTO DESCARGUE.',
  ),
  pesoLlenado: txt(
    'Peso al llenar el contenedor (kg). En la base de la bodega: PESO LLENADO.',
    'Weight when filling the container (kg). In the warehouse database: PESO LLENADO.',
  ),
  precintoLlenado: txt(
    'Precinto al llenar el contenedor. En la base de la bodega: PRECINTO LLENADO.',
    'Seal when filling the container. In the warehouse database: PRECINTO LLENADO.',
  ),
  tmOrigen: txt('Ciudad de origen, de la declaración de valor.', 'Origin city, from the value declaration.'),
  tmPunto: txt(
    'Punto de entrega (bodega), de la declaración de valor.',
    'Delivery point (warehouse), from the value declaration.',
  ),
  tmBigBags: txt('Big Bags declarados en la recolección.', 'Big Bags declared in the pickup.'),
  tmHumedo: txt('Peso húmedo total declarado (kg).', 'Total declared wet weight (kg).'),
  tmValor: txt('Valor total declarado en USD para el transporte.', 'Total value declared in USD for transport.'),
  tmSellos: txt(
    'Sellos del camión por tipo, de la declaración de valor.',
    'Truck seals by type, from the value declaration.',
  ),
  declSello: txt('Sello del Big Bag en la declaración de valor.', 'Big Bag seal in the value declaration.'),
  declHumedo: txt('Peso húmedo declarado (kg).', 'Declared wet weight (kg).'),
  declSeco: txt(
    'Peso seco declarado (kg); los formatos antiguos no lo traen.',
    'Declared dry weight (kg); older formats do not have it.',
  ),
  declAuGt: txt(
    'Tenor de oro declarado (g/t), estimado por la planta.',
    'Declared gold grade (g/t), estimated by the plant.',
  ),
  declAuOz: txt('Onzas de oro declaradas.', 'Declared gold ounces.'),
  declValor: txt('Valor declarado en USD para el transporte.', 'Value declared in USD for transport.'),
  // Tablas de lotes y tulas.
  lote: txt('Código del lote en la hoja EMPAQUE de la planta.', 'Lot code in the plant’s EMPAQUE sheet.'),
  loteEnvio: txt('Envío de planta del lote.', 'Plant shipment of the lot.'),
  loteFecha: txt('Fecha de envío: salida de El Bagre.', 'Shipping date: departure from El Bagre.'),
  loteHumedo: txt('Peso de concentrado húmedo (kg).', 'Wet concentrate weight (kg).'),
  loteSeco: txt('Peso de concentrado seco (kg).', 'Dry concentrate weight (kg).'),
  loteAuGt: txt('Tenor de oro del lote (g/t).', 'Gold grade of the lot (g/t).'),
  loteAuG: txt('Gramos de oro del lote.', 'Grams of gold in the lot.'),
  loteAgG: txt('Gramos de plata del lote.', 'Grams of silver in the lot.'),
  tula: txt('Código de la tula (hoja Bolsas por Lote).', 'Sack code (Bolsas por Lote sheet).'),
  tulaSellos: txt('Sellos interno y externo que puso la planta.', 'Inner and outer seals put on by the plant.'),
  tulaIngreso: txt('Ingreso a la bodega de Cartagena.', 'Entry to the Cartagena warehouse.'),
  tulaPrecinto: txt('Precinto con que ingresó a la bodega.', 'Seal it entered the warehouse with.'),
  tulaSalida: txt('Salida de la bodega (llenado del contenedor).', 'Departure from the warehouse (container filling).'),
  tulaContenedor: txt('Contenedor de exportación.', 'Export container.'),
  tulaNota: txt(
    'Resultado del cruce con la bodega. Amarillo = sin registro; rojo = el sello no cuadra.',
    'Result of the check against the warehouse. Yellow = no record; red = the seal does not match.',
  ),
};

// Nota de una columna o campo por su id (vacía si no tiene).
export const ayudaDeBigBag = (id: string): Texto | undefined => (AYUDA_BIG_BAG as Record<string, Texto>)[id];
export const ayudaDeViaje = (id: string): Texto | undefined => (AYUDA_VIAJE as Record<string, Texto>)[id];
